import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=654bf076&"
import script from "./Subscribers.vue?vue&type=script&lang=js&"
export * from "./Subscribers.vue?vue&type=script&lang=js&"
import style0 from "./Subscribers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Subscribers.vue"
export default component.exports